import React from "react";

type PlusIconProps = React.SVGProps<SVGSVGElement>;

export const PlusIcon = ({
  width = 20,
  height = 20,
  ...props
}: PlusIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.7143 10.953H10.9524V15.7149C10.9524 15.9675 10.852 16.2098 10.6734 16.3884C10.4948 16.567 10.2526 16.6673 9.99998 16.6673C9.74739 16.6673 9.50515 16.567 9.32654 16.3884C9.14794 16.2098 9.0476 15.9675 9.0476 15.7149V10.953H4.28569C4.03311 10.953 3.79087 10.8527 3.61226 10.6741C3.43365 10.4955 3.33331 10.2532 3.33331 10.0007C3.33331 9.74806 3.43365 9.50582 3.61226 9.32722C3.79087 9.14861 4.03311 9.04827 4.28569 9.04827H9.0476V4.28637C9.0476 4.03378 9.14794 3.79154 9.32654 3.61293C9.50515 3.43432 9.74739 3.33398 9.99998 3.33398C10.2526 3.33398 10.4948 3.43432 10.6734 3.61293C10.852 3.79154 10.9524 4.03378 10.9524 4.28637V9.04827H15.7143C15.9669 9.04827 16.2091 9.14861 16.3877 9.32722C16.5663 9.50582 16.6666 9.74806 16.6666 10.0007C16.6666 10.2532 16.5663 10.4955 16.3877 10.6741C16.2091 10.8527 15.9669 10.953 15.7143 10.953Z"
      fill="white"
    />
  </svg>
);

export default PlusIcon;
